import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useContractors = (enabled?: boolean) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['contractors'],
    queryFn: () =>
      api
        .postBackContractorsListFilter({
          postBackContractorsListFilterRequest: {
            data: {
              active: true,
            },
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
